import pickBy from './pickBy.js';

/**
 * Creates an object composed of the own enumerable property keys of object that are not omitted.
 * Similar to omit, but only own properties are picked and with better performance.
 *
 * Sources:
 * - https://lodash.com/docs/4.17.15#pick
 * - https://lodash.com/docs/4.17.15#omit
 * @param {object} object The source object
 * @param  {...string} keys The property keys to omit
 * @returns {object} The new object with all keys picked except omitted ones.
 */
const pickExcept = (object, ...keys) => {
  return pickBy(object, (value, key) => !keys.includes(key));
};

export default pickExcept;
